import React from 'react';
import { Button } from '@mui/material';
import { CreditCard as CreditIcon } from '@mui/icons-material';

/** "Add Credits" button — app theme, small size; same in Header and Subscription. variant="contained" for filled green on Subscription. */
const AddCreditsButton = ({ onClick, disabled = false, size = 'small', variant = 'outlined', sx = {}, ...rest }) => (
  <Button
    variant={variant}
    color="primary"
    size={size}
    startIcon={<CreditIcon />}
    onClick={onClick}
    disabled={disabled}
    sx={{
      fontWeight: 600,
      textTransform: 'none',
      minWidth: 100,
      ...sx,
    }}
    {...rest}
  >
    Add Credits
  </Button>
);

export default AddCreditsButton;
